module.exports = __webpack_public_path__ + "static/media/pin_servicos.c22e7fdc.png";